import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { translations } from "@/i18n/translations";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function Home() {
  const [lang, setLang] = useState("es");
  const t = translations[lang];

  return (
    <div className="App font-body" data-testid="home-page" data-lang={lang}>
      <Navbar lang={lang} setLang={setLang} t={t} />
      <Hero t={t} />
      <About t={t} />
      <MenuSection t={t} />
      <Gallery t={t} />
      <Reviews t={t} />
      <Contact t={t} />
      <Footer t={t} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
